<template lang="pug">
f7-page#apply-password-reset
  navbar(title="パスワード再設定の反映")

  background
    apply-password-form(
      ref="form"
      v-model="isValid"
      :error="error"
    )

    .button-area
      large-button(
        title="パスワードを再設定"
        :disabled="!isValid"
        @click="submit"
      )
</template>

<style lang="scss" scoped>
.page-content {
  padding-top: 60px !important;
  position: relative;
  overflow: hidden;
}
.button-area {
  position: absolute;
  bottom: 32px;
  width: 100%;
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'
import ApplyPasswordForm from '@/components/organisms/ApplyPasswordForm'
import LargeButton from '@/components/atoms/LargeButton'
import { IS_VALID_RESET_TOKEN, APPLY_PASSWORD_RESET } from '@/graphql'

export default {
  mixins: [PageTitle],
  title: 'パスワード再設定',
  components: {
    ApplyPasswordForm,
    LargeButton,
  },
  data() {
    return {
      isValid: false,
      error: {},
      passwordConfirm: '',
    }
  },
  methods: {
    async checkTokenWithNavigate() {
      const isPaserd = await this.urlParams
      if (isPaserd.token !== undefined) {
        const mutator = IS_VALID_RESET_TOKEN(this.urlParams)
        const result = await this.$apollo.mutate(mutator)
        this.checkToken(result)
      } else {
        this.redirectErrorPage()
      }
    },
    checkToken(params) {
      if (!params.data.isValidResetToken) {
        this.redirectErrorPage()
      }
    },
    async submit() {
      this.error.message = ''
      return new Promise((resolve) => {
        this.applyPasswordReset(this.urlParams.token)
          .then(resolve)
          .catch(this.handleError)
      })
    },
    async applyPasswordReset(token) {
      const resetToken = token
      const password = this.$refs['form']._data.passwordConfirm
      const variables = { resetToken, password }
      const mutator = APPLY_PASSWORD_RESET(variables)
      const result = await this.$apollo.mutate(mutator).catch(this.handleError)
      if (result.data) {
        this.navigatePage()
      }
    },
    navigatePage() {
      this.$f7router.navigate({ name: 'PublicApplyPasswordResetDone' })
    },
    redirectErrorPage() {
      this.$f7router.navigate({ name: 'PublicInvalidToken' })
    },
  },
  mounted() {
    this.checkTokenWithNavigate()
  },
}
</script>
